import { useRef } from "react";
import AnalysisLstatGraph from "./AnalysisLstatGraph";
import styles from "./styles.module.scss";
import { AnalysisLstatLogsGraphInterface } from "../../../interfaces/fe.interfaces";

export interface AnalysisLstatGraphGroupProps {
  graphs: AnalysisLstatLogsGraphInterface[]
}

const CLASS_MODIFIERS = {
  ONE_COL: "wisaAnalysisLstatGraphGroupOneCol",
  TWO_COL: "wisaAnalysisLstatGraphGroupTwoCol",
  THREE_COL: "wisaAnalysisLstatGraphGroupThreeCol",
};

const BREAKPOINTS = {
  MOBILE: 400,
  TABLET: 700,
  DESKTOP: 1500
};

const AnalysisLstatGraphGroup = ({graphs}: AnalysisLstatGraphGroupProps) => {
  const refContainer = useRef<HTMLDivElement>(null);

  let graphDims = {width: 700, height: 360};
  let classModifier = CLASS_MODIFIERS.ONE_COL;
  if(refContainer.current) {
    const containerWidth = refContainer.current.offsetWidth;
    // Aspect ratio for graph widths
    // 35/18 700,360
    // W
    // 3 column: 35 * 15 = 525
    // 2 column: 35 * 23 = 805
    // 1 column: 35 * 46 = 1610
    if (graphs.length >= 3 || (containerWidth <= BREAKPOINTS.MOBILE)) {
      let maxGraphs = Math.floor(containerWidth / 35);
      maxGraphs = Math.floor(maxGraphs / 3);
      const width = 35 * (maxGraphs - 3);
      const height = 18 * (maxGraphs - 3);
      graphDims = {width, height};
      classModifier = CLASS_MODIFIERS.THREE_COL;
    } else if (graphs.length === 2 || (containerWidth >= BREAKPOINTS.TABLET && containerWidth < BREAKPOINTS.DESKTOP)) {
      let maxGraphs = Math.floor(containerWidth / 35);
      maxGraphs = Math.floor(maxGraphs / 2);
      const width = 35 * (maxGraphs - 5);
      const height = 18 * (maxGraphs - 5);
      graphDims = {width, height};
      classModifier = CLASS_MODIFIERS.TWO_COL;
    } else if (containerWidth >= BREAKPOINTS.DESKTOP) {
      let maxGraphs = Math.floor(containerWidth / 35);
      maxGraphs = Math.floor(maxGraphs / 1);
      const width = 35 * (maxGraphs - 6);
      const height = 18 * (maxGraphs - 6);
      graphDims = {width, height};
      classModifier = CLASS_MODIFIERS.ONE_COL;
    }
  }

  return <div className={`${styles.wisaAnalysisLstatGraphGroup} ${styles[classModifier]}`} ref={refContainer}>
    {
      graphs.map((graph, index) => (
        <AnalysisLstatGraph key={`${graph.version}-${index}`} graph={graph} width={graphDims.width} height={graphDims.height} />
      ))
    }
  </div>;
};

export default AnalysisLstatGraphGroup;